import axios from 'axios';

import axiosInstance from '../../../utils/axios';
import { AvailableTransactionInstrumentDTO, CustomApiResponse } from './models';

export const getAvailableWithdrawInstruments = async (): Promise<AvailableTransactionInstrumentDTO[]> => {
  try {
    const response = await axiosInstance.get<CustomApiResponse<AvailableTransactionInstrumentDTO[]>>(
      'transaction/available/withdraw/instruments',
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data?.error || 'UNKNOWN_ERROR';
    }
    throw error;
  }
};
